<template>
  <div>
    <FormComponent
      @searchForm="getFormData"
      :searchFormItem="formItem"
      :labelWidth="140"
      ref="FormComponent"
      @handleReset="handleReset"
    >
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot1">
        <FormItem label="" :label-width="0">
          <RadioGroup
            v-model="formItem.achStage"
            @on-change="achStageOnChange"
            style="display:flex;justify-content: space-between"
          >
            <Radio label="目标设定"
              ><!-- 目标设定 -->{{ $t("Objective_Setting") }}</Radio
            >
            <Radio label="阶段回顾"
              ><!-- 阶段回顾 -->{{ $t("Phase_Review") }}</Radio
            >
            <Radio label="年终总结"
              ><!-- 年终总结 -->{{ $t("End-Year_Review_Over") }}</Radio
            >
            <Radio label="STI更新"
              ><!-- STI更新 -->{{ $t("STI_Update") }}</Radio
            >
          </RadioGroup>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot2">
        <FormItem :label="$t('STI_Self')"
          ><!-- STI -->
          <Input v-model="formItem.stiTarget" clearable />
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot3">
        <FormItem :label="$t('Detailed_Description')"
          ><!-- 详细描述 -->
          <Input v-model="formItem.details" clearable />
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot4">
        <FormItem :label="$t('Start_Date')"
          ><!-- 开始日期 -->
          <DatePicker
            type="daterange"
            :transfer="true"
            v-model="formItem.beginDate"
            style="width:100%"
            clearable
            @on-change="formItem.beginDate = $event"
          ></DatePicker>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot5">
        <FormItem :label="$t('End_Date')"
          ><!-- 结束日期 -->
          <DatePicker
            type="daterange"
            :transfer="true"
            v-model="formItem.afterDate"
            style="width:100%"
            clearable
            @on-change="formItem.afterDate = $event"
          ></DatePicker>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot6">
        <FormItem :label="$t('Milestone1')"
          ><!-- 里程碑1 -->
          <Input v-model="formItem.milepost1" clearable />
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot7">
        <FormItem :label="$t('Milestone2')"
          ><!-- 里程碑2 -->
          <Input v-model="formItem.milepost2" clearable />
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot8">
        <FormItem :label="$t('Milestone3')"
          ><!-- 里程碑3 -->
          <Input v-model="formItem.milepost3" clearable />
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot9">
        <FormItem :label="$t('Data_Source')"
          ><!-- 数据来源 -->
          <Input v-model="formItem.dataSource" clearable />
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot10">
        <FormItem :label="$t('Milestones_Obtained')"
          ><!-- 达成比例 -->
          <Select v-model="formItem.reachRatio" clearable>
            <Option
              v-for="item in STIProportion"
              :value="item.ch_value"
              :key="item.code"
              >{{ item.ch_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="24" :lg="6" slot="slot11">
        <FormItem :label="$t('Completion_Status')"
          ><!-- 实际完成情况 -->
          <Input v-model="formItem.finishDataSource" clearable />
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot12">
        <FormItem :label="$t('Special_adjustment')"
          ><!-- 是否特殊调整 -->
          <Select v-model="formItem.single" clearable>
            <Option
              v-for="item in yesOrNo"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="6"
        slot="slot13"
      >
        <FormItem :label="$t('Management_Level')"
          ><!-- 管理层级 -->
          <Select v-model="formItem.hrmanage" clearable>
            <Option
              v-for="item in ManagementLevel"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
    </FormComponent>
    <!-- <Table border :loading="loading" :columns="columns" :data="data" style="margin:20px 0">
            <template slot-scope="{ row, index }" slot="action">
                <Button type="primary" icon="md-reorder" size="small" @click="checkBtn(row, index)"></Button>
            </template>
        </Table>
        <Table border :loading="loading" :columns="columnsA" :data="dataA" style="margin:20px 0" ref="table" v-show="false"></Table>  -->
    <!-- <div style="margin:20px 0;display:flex; justify-content: flex-end;flex-direction: column; align-items: flex-end;">
            <Page :total="total" :current="pageInfo.pageNo" :page-size="pageInfo.pageSize" transfer
             @on-change="pageChange" :page-size-opts="[10,50,100,150]" show-sizer @on-page-size-change="pageSizeChange" /> -->
    <!-- <Button type="primary" style="margin-top:15px"  @click="exportData()">导出{{$t('PB_Export')}}</Button> -->
    <!-- </div> -->
    <STIPersonalGoalsA
      ref="STIPersonalGoalsA"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      v-show="nowShow == '目标设定'"
    ></STIPersonalGoalsA>
    <STIPersonalGoalsB
      ref="STIPersonalGoalsB"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      v-show="nowShow == '阶段回顾'"
    ></STIPersonalGoalsB>
    <STIPersonalGoalsC
      ref="STIPersonalGoalsC"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      v-show="nowShow == '年终总结'"
    ></STIPersonalGoalsC>
    <STIPersonalGoalsD
      ref="STIPersonalGoalsD"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      v-show="nowShow == 'STI更新'"
    ></STIPersonalGoalsD>
  </div>
</template>

<script>
import FormComponent from "./FormComponent.vue";
import axios from "axios";
import DateUtil from "../../../../util/DateUtil";
import STIPersonalGoalsA from "./tableComponents/STIPersonalGoalsA.vue";
import STIPersonalGoalsB from "./tableComponents/STIPersonalGoalsB.vue";
import STIPersonalGoalsC from "./tableComponents/STIPersonalGoalsC.vue";
import STIPersonalGoalsD from "./tableComponents/STIPersonalGoalsD.vue";
export default {
  components: {
    FormComponent,
    STIPersonalGoalsA,
    STIPersonalGoalsB,
    STIPersonalGoalsC,
    STIPersonalGoalsD
  },
  data() {
    return {
      date: new DateUtil(),
      searchItem: {
        achStage: "目标设定"
      },
      formItem: {
        achStage: "目标设定"
      },
      loading: false,
      STIProportion: [],
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      data: [],
      dataA: [],
      nowShowVal: "目标设定",
      nowShow: "目标设定",
      yesOrNo: [],
      ManagementLevel: [],
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  mounted() {
    // this.getData()
    // this.getListData()
    this.searchItem.year = JSON.parse(sessionStorage.getItem("userInfo")).year;
  },
  methods: {
    achStageOnChange(val) {
      this.nowShowVal = val;
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData(JSON.stringify(this.searchItem));
    },
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then(res => {
        if (res) {
          this.$refs.FormComponent.positionList = res.positionList;
          this.$refs.FormComponent.departmentList = res.departmentList;
          this.$refs.FormComponent.businessUnitList = res.businessUnitList;
          this.$refs.FormComponent.Level = res.Level;
          this.$refs.FormComponent.salesAreaList = res.salesAreaList;
          this.$refs.FormComponent.YesOrNo = res.YesOrNo;
          this.$refs.FormComponent.BeQuit = res.BeQuit;
          this.STIProportion = res.STIProportion;
          this.$refs.FormComponent.personnelType = res.personnelType;
          this.$refs.FormComponent.functionList = res.functionList;
          this.yesOrNo = res.YesOrNo;
          this.ManagementLevel = res.ManagementLevel;
        }
      });
    },
    getData(item) {
      item ? (this.searchItem = JSON.parse(item)) : "";
      if (this.formItem.single == "1") {
        this.formItem.achStage = "STI更新";
        this.searchItem.achStage = "STI更新";
        this.achStageOnChange("STI更新");
      }
      // this.searchItem.startDate?this.searchItem.startDate=this.date.dateVal(this.searchItem.startDate,'YYYY-MM-DD'):''
      // this.searchItem.endDate?this.searchItem.endDate=this.date.dateVal(this.searchItem.endDate,'YYYY-MM-DD'):''
      let obj = {
        serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
          .serialnumber,
        ...this.searchItem,
        ...this.pageInfo
      };
      this.loading = true;
      if (this.formItem.achStage == "目标设定") {
        this.$refs.STIPersonalGoalsA.loading = true;
      } else if (this.formItem.achStage == "阶段回顾") {
        this.$refs.STIPersonalGoalsB.loading = true;
      } else if (this.formItem.achStage == "年终总结") {
        this.$refs.STIPersonalGoalsC.loading = true;
      } else {
        this.$refs.STIPersonalGoalsD.loading = true;
      }
      this.nowShow = this.nowShowVal;
      axios.post("/achReport/selectStiTargetInfo", obj).then(res => {
        if (this.formItem.achStage == "目标设定") {
          this.$refs.STIPersonalGoalsA.data = res.data;
          this.$refs.STIPersonalGoalsA.total = parseInt(res.pageInfo.total);
          this.$refs.STIPersonalGoalsA.loading = true;
          this.$refs.STIPersonalGoalsA.searchItem = this.searchItem;
        } else if (this.formItem.achStage == "阶段回顾") {
          if (res.data.length > 0) {
            this.$refs.STIPersonalGoalsB.data = res.data;
            this.$refs.STIPersonalGoalsB.total = parseInt(res.pageInfo.total);
            this.$refs.STIPersonalGoalsB.loading = true;
            this.$refs.STIPersonalGoalsB.searchItem = this.searchItem;
          }
        } else if (this.formItem.achStage == "年终总结") {
          this.$refs.STIPersonalGoalsC.data = res.data;
          this.$refs.STIPersonalGoalsC.total = parseInt(res.pageInfo.total);
          this.$refs.STIPersonalGoalsC.loading = true;
          this.$refs.STIPersonalGoalsC.searchItem = this.searchItem;
        } else {
          this.$refs.STIPersonalGoalsD.data = res.data;
          this.$refs.STIPersonalGoalsD.total = parseInt(res.pageInfo.total);
          this.$refs.STIPersonalGoalsD.loading = true;
          this.$refs.STIPersonalGoalsD.searchItem = this.searchItem;
        }
        this.$refs.FormComponent.prevent = false;
        this.loading = false;
        this.$refs.STIPersonalGoalsA.loading = false;
        this.$refs.STIPersonalGoalsB.loading = false;
        this.$refs.STIPersonalGoalsC.loading = false;
        this.$refs.STIPersonalGoalsD.loading = false;
      });
    },
    getFormData(item) {
      this.pageInfo.pageNo = 1;
      this.getData(item);
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData(JSON.stringify(this.searchItem));
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData(JSON.stringify(this.searchItem));
    },
    exportData() {
      let obj = {
        serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
          .serialnumber,
        ...this.searchItem,
        pageNo: 1,
        pageSize: 99999
      };
      this.loading = true;
      axios.post("/achReport/selectStiTargetInfo", obj).then(res => {
        if (res) {
          this.dataA = res.data;
          this.$nextTick(() => {
            this.$exportExcel(
              "table",
              this.$t("STI_Self") +
                this.$nowDate.dateVal(new Date(), "YYYY-MM-DD HH-mm")
            );
          });
        }
        this.loading = false;
      });

      // this.$refs.table.exportCsv({
      //     filename: 'STI个人目标'
      // });
    },
    checkBtn(row, index) {
      this.$router.push({
        path: "/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27",
        query: { id: row.id, serialnumber: row.serialnumber }
      });
    },
    handleReset() {
      if (this.formItem.achStage == "目标设定") {
        this.formItem = {
          achStage: "目标设定"
        };
      } else if (this.formItem.achStage == "阶段回顾") {
        this.formItem = {
          achStage: "阶段回顾"
        };
      } else {
        this.formItem = {
          achStage: "年终总结"
        };
        this.formItem.achStage = "年终总结";
      }

      this.serialnumber.year = this.date.dateVal(new Date(), "YYYY");
      // this.pageInfo.pageNo=1
      // this.getData(JSON.stringify(this.formItem))
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/STIPersonalGoals.vue